import { db } from "../firebase";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  serverTimestamp,
} from "firebase/firestore";
import { storage } from "../firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

const testimonialsCollection = collection(db, "testimonials");

export const getTestimonials = async () => {
  const snapshot = await getDocs(testimonialsCollection);
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};

export const createTestimonial = async (testimonial) => {
  const now = serverTimestamp();
  return await addDoc(testimonialsCollection, {
    ...testimonial,
    createdAt: now,
    updatedAt: now,
  });
};

export const updateTestimonial = async (id, testimonial) => {
  const testimonialRef = doc(db, "testimonials", id);
  return await updateDoc(testimonialRef, {
    ...testimonial,
    updatedAt: serverTimestamp(),
  });
};

export const deleteTestimonial = async (id) => {
  const testimonialRef = doc(db, "testimonials", id);
  return await deleteDoc(testimonialRef);
};

export const uploadTestimonialImage = async (file) => {
  const storageRef = ref(storage, `testimonials/${file.name}`);
  await uploadBytes(storageRef, file);
  return await getDownloadURL(storageRef);
};
